define('widgets/flipSwitch/viewmodel',['jquery'], function($) {
    var FlipSwitch = function() {
        var self = this;
        self.toggle = function() {
            self.isOn(!self.isOn());
        };
    };

    FlipSwitch.prototype.activate = function(settings) {
        this.isOn = settings.value;
    };

    FlipSwitch.prototype.compositionComplete = function(view, parent) {
        $(parent).addClass('inline-widget');
    };

    return FlipSwitch;
});
